<template lang="pug">
    fragment
        // Arrow
        td
            expand-component(:class="{'expanded' : expanded}")

        // Business Name
        td {{ item.name }}

        // Status
        td
            status-component.primaryColor(v-if="item.isActive")
            status-component.warningColor(v-else )

        // Actions
        td.px-0.text-xs-right
            // Users list button
            button-component.userList(:action="usersView" color="primary" icon="people")

            // Edit manager button
            button-component(:action="edit" color="primary" icon="edit")

            // Delete manager button
            button-component(:action="deleteManager" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import ExpandIcon from '~components/ExpandIcon';
    import Status from '~components/Status';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ExpandComponent: ExpandIcon,
            ButtonComponent: ButtonIcon,
            StatusComponent: Status
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        },
        methods: {
            ...mapActions('businesses', ['deleteAccount']),

            managerRole(role) {
                return role === 'instructor' ? 'I' : 'A';
            },

            /**
             * Users by business
             */
            usersView() {
                this.$router.push({
                    name: 'dashboard.users.by.business',
                    params: { id: this.item.id }
                });
            },

            /**
             * Edit manager
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.businesses.edit',
                    params: { id: this.item.id }
                });
            },

            async deleteManager() {
                const resp = await this.deleteAccount({ id: this.item.id });

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .role
        width: 30px
        height: 30px
        border-radius: 30px
        background-color: rgba(255, 255, 255, 0.2)
        text-align: center
        font-size: 22px

    .fullName
        max-width: 140px
        overflow: hidden
        text-overflow: ellipsis
</style>
